"use client";

import { useEffect } from "react";
import { setPageDocumentType } from "./pageContext";

/**
 * Tells the Salesforce tracking code which Sanity document type this route
 * renders. Render it once per route page, next to `HeaderEffect`:
 *
 *     <AnalyticsPageContext documentType={data._type} />
 *
 * The value is read when a page-view is sent (`source.pageType`). It renders
 * nothing, records nothing while `NEXT_PUBLIC_SF_PAGE_CONTEXT` is off, and
 * clears itself on unmount so a route without this component (search, 404)
 * falls back to the legacy constant instead of reporting the previous page.
 */
export function AnalyticsPageContext({ documentType }: { documentType: string }) {
    useEffect(() => setPageDocumentType(documentType), [documentType]);

    return null;
}
